import React, { useRef } from 'react';
import { useAlert } from 'react-alert';
import I18n from 'i18n-js';

import { hideCollection } from '@lootboy/lib/slices/cardCollections/actions';

import Alert from '~/components/Alert';
import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import BottomSheetDialog, {
  TBottomSheetDialogElement,
} from '~/components/molecules/BottomSheetDialog';

import useOnClose from '~/hooks/useOnClose';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

import styles from './RemoveCollectionDialog.module.scss';

interface IRemoveCollectionDialog {
  onClose: () => void;
  header: string;
  collectionId: string;
}

const RemoveCollectionDialog: React.FC<IRemoveCollectionDialog> = ({
  onClose,
  header,
  collectionId,
}) => {
  const goBack = useOnClose();
  const alert = useAlert();
  const dispatch = useAppDispatch();
  const dialogElement = useRef<TBottomSheetDialogElement>(null);

  const onCancel = () => {
    if (dialogElement.current) {
      dialogElement.current.close();
    }
  };

  const onRemove = async () => {
    try {
      await dispatch(hideCollection(collectionId));
      await dialogElement.current?.close();
      goBack();
    } catch (e) {
      alert.error(
        <Alert
          body={(e as { message: string })?.message}
          title={I18n.t('common_error')}
        />,
      );
      onCancel();
    }
  };

  return (
    <BottomSheetDialog
      ref={dialogElement}
      onClose={onClose}
      header={header}
    >
      <div className={styles.warning}>
        <h3>{I18n.t('collections_bs_hide_headline')}</h3>
        <p>{I18n.t('collections_bs_hide_sub')}</p>
      </div>
      <div className={styles.actions}>
        <StyledButton
          variant={EStyledButtonVariant.GRAY}
          onClick={onCancel}
        >
          {I18n.t('collections_bs_hide_sbutton')}
        </StyledButton>
        <StyledButton
          variant={EStyledButtonVariant.BLUE}
          onClick={onRemove}
        >
          {I18n.t('collections_bs_hide_pbutton')}
        </StyledButton>
      </div>
    </BottomSheetDialog>
  );
};

export default RemoveCollectionDialog;
